import {__t} from "@config/i18n";

export type BenefitTabKey = 'manage-benefits' | 'add-to-plans'
export const BenefitTabItems: { [K in BenefitTabKey]: string } = {
    'manage-benefits': __t('benefit.manage_benefits'),
    'add-to-plans': __t('benefit.add_to_plans'),
}
